export interface SimpleChartDataDTO {
  total: number;
  date?: Date;
  label: string;
  extraData: string;
}
